import axios from 'axios'
import Cookies from 'js-cookie'
import config from '@/config/config'

const plant = 2
const lang = navigator.language || navigator.userLanguage

// zh-cn 中文   zh-tw 繁体   en-us 英语
let $lang = lang.toLowerCase()
if (lang.toLowerCase() === 'zh-mo' || lang.toLowerCase() === 'zh-hk') {
  $lang = 'zh-tw'
} else if (lang.toLowerCase() === 'zh') {
  $lang = 'zh-cn'
}

const service = axios.create({
  baseURL: config.apiTest,
  timeout: 60000
})
service.interceptors.request.use(
  config => {
    const $version = Cookies.get('env') ? JSON.parse(Cookies.get('env')).data.version : '' // app版本号，这个变量声明必须在这
    console.log(`版本号:${$version}, 语言:${$lang} \n Token:${Cookies.get('token')}`)
    config.headers['width'] = document.body.offsetWidth
    config.headers['height'] = document.body.offsetHeight
    config.headers['plant'] = plant
    config.headers['lang'] = $lang
    config.headers['VERSION'] = $version
    if (Cookies.get('token')) {
      const token = JSON.parse(Cookies.get('token'))
      config.headers['Authorization'] = `Bearer ${token.data.auth_token}`
    } else if (Cookies.get('Mini-Token')) {
      console.log('Mini-Token', sessionStorage.getItem('Mini-Token'))
      config.headers['Authorization'] = `Bearer ${sessionStorage.getItem('Mini-Token')}`
    } else if (sessionStorage.getItem('token')) {
      const stoken = JSON.parse(sessionStorage.getItem('token'))
      config.headers['Authorization'] = `Bearer ${stoken.data.auth_token}`
    }

    // config.headers['Authorization'] = 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOi8vYXBpLnRlc3QvYnJhbmQvYnJhbmRfdG9rZW4iLCJpYXQiOjE2MjYwNjA1NDIsImV4cCI6MTc4MTU4MDU0MiwibmJmIjoxNjI2MDYwNTQyLCJqdGkiOiJLT3lvYWdMaDJUU3NjblF6Iiwic3ViIjo5ODI1MSwicHJ2IjoiYzM1ZGMyMjAwYWIzNTFjNTNjOTViZDI1MDVmYTlhNTMwYjcyYWZlZSJ9.GM4W5xRYe9TvJuNPexANyqolNGP43Fz0Q-Cj7kHr5GU'
    return config
  },
  error => {
    Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    const res = response.data
    return res
  },
  error => {
    return Promise.reject(error)
  }
)

export default service
